import gql from 'graphql-tag'

export default gql`
  mutation VerifyResetCode(
    $email: String!,
    $code: String!
  ) {
    verifyResetCode(
      email: $email,
      code: $code
    )
  }
`
